<section class="content">
  <div class="card" style="padding: 24px;">
    <div class="row">
      <div class="col" style="font-size: 23px; font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        Free Milk Report
      </div>
    </div>
    <div class="container-fluid">
      <div class="row g-3">
        <!-- Start Date -->
        <div class="col-md-2">
          <mat-label>From Date</mat-label>
          <input type="date" [(ngModel)]="start_date" (change)="updateEndDateOptions()"
            class="form-control main-border-class" />
        </div>

        <!-- End Date -->
        <div class="col-md-2">
          <mat-label>End Date</mat-label>
          <input type="date" [(ngModel)]="end_date" [min]="start_date" class="form-control main-border-class" />
        </div>

        <!-- Customer Type -->
        <div class="col-md-2">
          <mat-label>Select Customer Type</mat-label>
          <mat-select [(ngModel)]="selected_customer_types_id" multiple class="main-border-class"
            placeholder="Customer Type">
            <mat-option *ngFor="let customer_type of customer_type_list" [value]="customer_type.id">
              {{ customer_type.name }}
            </mat-option>
          </mat-select>
        </div>

        <!-- Union -->
      

        <!--customer Union -->
        <div class="col-md-2">
          <mat-label> union</mat-label>
          <mat-select [(ngModel)]="selectedUnionId" multiple class="main-border-class" placeholder="union">
            <mat-option *ngFor="let customer of customerunion" [value]="customer.id">
              {{ customer.name }}
            </mat-option>
          </mat-select>
        </div>

        <!-- Product Name -->
        <div class="col-md-2">
          <mat-label>Product Name</mat-label>
          <mat-select [(ngModel)]="selectedprodtId" multiple class="main-border-class" placeholder="Product Name">
            <mat-option *ngFor="let prodt of productname" [value]="prodt.id">
              {{ prodt.name }}
            </mat-option>
          </mat-select>
        </div>

        <!-- Get Button -->
        <div class="col-md-2  mt-2">
          <button mat-raised-button color="primary" (click)="getClicked()">
            Get
          </button>
        </div>
      </div>

      <!-- Progress Spinner -->
      <div *ngIf="!is_document_available" class="text-center mt-4">
        <mat-progress-spinner [color]="color" [mode]="mode" [diameter]="100"></mat-progress-spinner>
      </div>

      <!-- Download Section -->
      <div class="row mt-3" *ngIf="document_file !== null">
        <div class="col-md-6"></div>
        <div class="col-md-6 text-end">
          <button mat-raised-button color="accent" (click)="downloadClicked()">
            <mat-icon>get_app</mat-icon> Download Excel
          </button>
        </div>
      </div>
    </div>


  </div>
</section>